import { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/axios';
import { clearCachedUser, getCachedUser, saveCachedUser } from '../offline/session';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const { data } = await api.get('/auth/user');
      setUser(data);
      saveCachedUser(data);
    } catch (err) {
      // امسح التوكن فقط في حالة Unauthorized الحقيقية
      if (err?.response?.status === 401) {
        localStorage.removeItem('token');
        clearCachedUser();
        setUser(null);
      } else if (!err?.response) {
        // لا اتصال: نكمل بآخر بيانات مستخدم محفوظة على الجهاز حتى يعمل إدخال الفحوصات دون إنترنت.
        setUser(getCachedUser());
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const login = async (username, password, auctionId = null) => {
    const { data } = await api.post('/auth/login', {
      username: String(username || '').trim(),
      password: String(password || '').trim(),
      auction_id: auctionId ? Number(auctionId) : null,
    });
    localStorage.setItem('token', data.token);
    setUser(data.user);
    // رد الدخول لا يحمل قائمة المزادات كاملة؛ نحفظ النسخة الكاملة من /auth/user.
    saveCachedUser(data.user);
    api.get('/auth/user').then(({ data: fullUser }) => saveCachedUser(fullUser)).catch(() => {});
    return data;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch {
      // ignore network/token errors on logout
    }
    localStorage.removeItem('token');
    clearCachedUser();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refreshUser: fetchUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
